<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addTag" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加指标</el-button>
      </div>
      <ele-data-table ref="table" :config="table" highlight-current-row>
        <template>
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
          <el-table-column label="名称" prop="tagName" align="center" />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.status == 0 ? '正常' : '禁用' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="scope">
              <el-link type="primary" icon="el-icon-edit" :underline="false" @click="handleUpdate(scope.row)">修改</el-link>
              <el-link icon="el-icon-delete" type="danger" :underline="false" @click="handleDelete(scope.row)">删除</el-link>
              <el-link type="warning" icon="el-icon-view" @click="viewNorm(scope.row)">查看小类</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!--表单弹窗-->
      <el-dialog
        :title="title"
        :visible.sync="open"
        width="300px"
        append-to-body
        :destroy-on-close="true"
        custom-class="ele-dialog-form"
        :lock-scroll="false"
        @close="reset"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="指标名称" prop="tagName">
            <el-input v-model="form.tagName" placeholder="请输入指标名称" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  import { tagPage, saveTag, delTag } from '@/config/ipadComputer/tag';

  export default {
    name: 'tagList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/classRoom/tagPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        queryParams: {},
        title: '修改指标',
        // 是否显示弹出层
        open: false,
        // 编辑项
        form: {},
        // 验证规则
        rules: {
          tagName: [{ required: true, message: '指标名称不能为空', trigger: 'blur' }],
        },
      };
    },
    methods: {
      addTag() {
        this.title = '添加指标';
        this.open = true;
        this.reset();
      },
      // 表单重置
      reset() {
        this.form = {
          tagName: undefined,
        };
        this.$refs['form'].resetFields();
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        this.title = '修改指标';
        this.form = this.$util.deepClone(row);
        this.open = true;
      },
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.form) {
              if (this.form[key] !== null && this.form[key] !== undefined) {
                formData.append(key, this.form[key]);
              }
            }
            saveTag(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: '成功' });
                this.open = false;
                this.$refs.table.reload();
              }
            });
          }
        });
      },
      // 删除大类
      /** 删除按钮操作 */
      handleDelete(row) {
        const id = row.id;
        this.$confirm('是否确认删除该指标？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function() {
            const formdata = new FormData();
            formdata.append('id', id);
            formdata.append('status', 2);
            return delTag(formdata);
          })
          .then(() => {
            this.$refs.table.reload();
            this.$message({ type: 'success', message: '删除成功' });
          })
          .catch(() => {});
      },
      // 查看小类
      viewNorm(row) {
        const tagId = row.id;
        this.$router.push('/ipadComputer/secondTag/' + tagId);
      },
    },
  };
</script>

<style scoped lang="scss"></style>
